import React, {useEffect} from "react";
import CompletedInterview from "./cards/CompletedInterview";
import Card from "./cards/Card";
import "./InterviewerCompleted.css";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DatePicker from "react-date-picker";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import Footer from "../Home/Footer";

const InterviewerCompleted = () => {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 100);
  }, []);
  function TransitionRight(props) {
    setDate(null);
    return <Slide {...props} direction="right" />;
  }
  const [date, setDate] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [transition, setTransition] = React.useState(undefined);
  const handleClick = (Transition) => () => {
    setTransition(() => Transition);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <Helmet>
        <title>Interwiu | Completed Interviews</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="completed-interview interviews">
        <div className="inteviews-container"></div>
        <div className="flex justify-center items-center my-4" id="head">
          <h2 className="interview-head text-2xl font-medium">
            Completed Interviews (12)
          </h2>
        </div>
        <div className="interview-cont">
          <div className="flex justify-between mx-8">
            <div>
              Showing the results for {date ? date.toDateString() : "all days"}
            </div>
            <div className="flex gap-2">
              <label htmlFor="date">Filter by Date: </label>
              <DatePicker
                onChange={(newValue) => {
                  setDate(newValue);
                }}
                value={date}
              />
            </div>
          </div>
          <div className="interviews-list">
            {/* <div className="relative w-full h-full" style={{ height: "280px" }}> */}
            <Card />
            {/* </div> */}
            <CompletedInterview />
            <CompletedInterview />
            <CompletedInterview />
            <CompletedInterview />
            <CompletedInterview />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default InterviewerCompleted;
